var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "new-google-business-channel-form" } },
    [
      _c("a-form", [
        _c("div", { staticClass: "form-wrapper" }, [
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("googleBusiness.channelName"))),
              ]),
              _vm._v(" "),
              _c(
                "a-form-item",
                {
                  attrs: {
                    "validate-status": _vm.getErrorStatus("channelName"),
                    help: _vm.getErrorMessage("channelName"),
                  },
                },
                [
                  _c("a-input", {
                    ref: "channelName",
                    attrs: {
                      placeholder: _vm.$t("googleBusiness.channelName"),
                      name: "channelName",
                    },
                    model: {
                      value: _vm.form.channelName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "channelName", $$v)
                      },
                      expression: "form.channelName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "connect-body" }, [
            _c("div", { staticClass: "requirements" }, [
              _c("div", [
                _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
                _vm._v(_vm._s(_vm.$t("googleBusiness.ensureGoogleAccount"))),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
                _vm._v(_vm._s(_vm.$t("googleBusiness.ensureBusinessProfile"))),
              ]),
            ]),
            _vm._v(" "),
            _c("strong", [
              _vm._v(
                " " + _vm._s(_vm.$t("googleBusiness.permissionDesc")) + " "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("a-checkbox", {
                  attrs: { checked: _vm.termOfService },
                  on: {
                    change: function ($event) {
                      return _vm.acceptTermOfService("pp")
                    },
                  },
                }),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("search.integration.readAndAgree")) +
                      "\n                        "
                  ),
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.acceptTermOfService("pp")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("search.integration.privatePolicy")))]
                  ),
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("message.and")) +
                      "\n                        "
                  ),
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.acceptTermOfService("tac")
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("search.integration.termsAndCondition"))
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "SupsisButton",
              { attrs: { ghost: "" }, on: { click: _vm.handleCancel } },
              [_vm._v(" " + _vm._s(_vm.$t("wp.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: {
                  primary: "",
                  disabled: !_vm.termOfService || _vm.loading,
                  loading: _vm.loading,
                },
                on: { click: _vm.handleSubmit },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("googleBusiness.connectToGoogleBusiness")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.termOfServiceModal
        ? _c("TermOfService", {
            attrs: { type: _vm.termOfServiceModal },
            on: {
              agree: _vm.acceptedTermOfService,
              cancel: function ($event) {
                _vm.termOfServiceModal = null
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }